export enum AppRoute {
    START = "/",
    HOME = "/home",
    APPS = "/apps",
    WEB = "/web",
    DESKTOP = "/desktop",
    VISIONS = "/visions",
    ABOUT = "/about",
    NOT_FOUND = "*",
}